export var TOGGLE_CANCEL_ORDER = 'TOGGLE_CANCEL_ORDER';
export var MDM_TOGGLE_ALMA = 'MDM_TOGGLE_ALMA';
export var MDM_TOGGLE_PAYPAL_EXPRESS = 'MDM_TOGGLE_PAYPAL_EXPRESS';
export var MDM_TOGGLE_OP_CO = 'MDM_TOGGLE_OP_CO';
export var INVERTED_FLAGS = [TOGGLE_CANCEL_ORDER, MDM_TOGGLE_PAYPAL_EXPRESS, MDM_TOGGLE_ALMA, MDM_TOGGLE_OP_CO];
export var LOCALIZED_FLAGS = {
  [MDM_TOGGLE_ALMA]: {
    'fr-FR': true,
    'nl-BE': false,
    'fr-BE': false,
    'de-DE': false,
    'es-ES': false,
    'it-IT': false,
    'fr-LU': false,
    'nl-NL': false,
    'de-AT': false,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': false
  },
  [MDM_TOGGLE_OP_CO]: {
    'fr-FR': true,
    'nl-BE': false,
    'fr-BE': false,
    'de-DE': false,
    'es-ES': false,
    'it-IT': false,
    'fr-LU': false,
    'nl-NL': false,
    'de-AT': false,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': false
  }
};
export var UNLEASH_FEATURES = {
  PROMOCODEAPPLY: 'promo-code-apply',
  SELFCAREREVERSIO: 'selfcare-reversio',
  VP: 'private-sale',
  WHISHLIST: 'wishlist',
  FREEHOMEDELIVERY: 'display-free-home-delivery',
  APPSHOP_PILOTES: 'alma-payment-in-store',
  CONTACT_WEBFORMS: 'contact-webforms'
};